import React from 'react';
import { useNextStep, CardComponentProps } from 'nextstepjs';

import {
  Card,
  Stack,
  Button,
  Typography,
  CardContent,
  CardActions,
  LinearProgress,
} from '@mui/material';

type MainTourActionsProps = {
  currentStep: number;
  totalSteps: number;
};

function MainTourActions({ currentStep, totalSteps }: MainTourActionsProps) {
  const { currentTour } = useNextStep();

  if (currentTour !== 'mainTour') return null;

  return (
    <>
      {currentStep === totalSteps - 1 && (
        <Button
          variant="contained"
          size="small"
          color="primary"
          sx={{ fontSize: '0.70rem' }}
          onClick={() => window.open('https://ajuda.zekitec.com.br/', '_blank')}
        >
          Central de Ajuda
        </Button>
      )}
      {currentStep === totalSteps - 2 && (
        <Button
          variant="contained"
          size="small"
          color="primary"
          sx={{ fontSize: '0.70rem' }}
          onClick={() =>
            window.open(
              'https://calendly.com/contato-zekitec/demo?embed_type=Inline&hide_landing_page_details=1&hide_gdpr_banner=1&month=2025-09',
              '_blank'
            )
          }
        >
          Agendar Reunião
        </Button>
      )}
    </>
  );
}

const WizardCard: React.FC<CardComponentProps> = ({
  step,
  currentStep,
  totalSteps,
  nextStep,
  prevStep,
  skipTour,
  arrow,
}) => (
  <Card
    sx={{
      width: 265,
      padding: 2,
      overflow: 'visible',
      zIndex: 2000,
    }}
  >
    {/* Título + Ícone */}
    <Stack direction="row" alignItems="end" justifyContent="space-between" mb={4}>
      <Typography variant="body1" fontWeight={600}>
        {step.title}
      </Typography>

      {step.icon && <Typography variant="h5">{step.icon}</Typography>}
    </Stack>

    {/* Conteúdo */}
    <CardContent sx={{ p: 0, mb: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Typography variant="body2" color="text.secondary">
        {step.content}
      </Typography>

      <MainTourActions currentStep={currentStep} totalSteps={totalSteps} />
    </CardContent>

    {/* Barra de progresso */}
    <LinearProgress
      variant="determinate"
      value={((currentStep + 1) / totalSteps) * 100}
      sx={{ height: 10, borderRadius: 3, mb: 2 }}
    />

    {/* Seta (arrow) */}
    {arrow}

    {/* Rodapé com navegação */}
    <CardActions
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
        p: 0,
      }}
    >
      {/* Linha Step + Buttons */}
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{ width: '100%', mb: 1.5 }}
      >
        <Typography variant="caption" color="text.secondary">
          {`Passo ${currentStep + 1} de ${totalSteps}`}
        </Typography>

        <Stack direction="row" spacing={1}>
          {currentStep > 0 && (
            <Button variant="soft" size="small" onClick={prevStep} sx={{ fontSize: '0.70rem' }}>
              Anterior
            </Button>
          )}

          <Button
            variant="contained"
            color="primary"
            size="small"
            onClick={nextStep}
            sx={{ fontSize: '0.70rem' }}
          >
            {currentStep === totalSteps - 1 ? 'Fim' : 'Próximo'}
          </Button>
        </Stack>
      </Stack>

      {/* Botão Skip */}
      {step.showSkip && skipTour && (
        <Button variant="soft" size="small" onClick={skipTour} sx={{ fontSize: '0.70rem' }}>
          Pular Tour
        </Button>
      )}
    </CardActions>
  </Card>
);

export default WizardCard;
